import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";

function useAccountingDonePermissions() {
  const checkRelations = useCheckRelations();

  const isAccountingCompletedInfoAvailable = () => {
    return checkRelations.hasRelations([
      AuthEnums.PersonCompanyRelationType.Admin,
      AuthEnums.PersonCompanyRelationType.Advisor,
      AuthEnums.PersonCompanyRelationType.Contact,
      AuthEnums.PersonCompanyRelationType.Reports,
    ]);
  };

  return { isAccountingCompletedInfoAvailable };
}

export default useAccountingDonePermissions;
